export const dentalProposalData = {
  logos: {
    clyniCall: true,
    platinumDental: "https://customer-assets.emergentagent.com/job_revenue-recovery-13/artifacts/a1y0u9yw_pdc_blue_backround_logo.jpg"
  },

  hero: {
    headline: "How Platinum Dental Can Increase Booked Appointments by 15-25% in 30 Days",
    subheadline: "A tailored revenue capture system designed around your current workflow"
  },

  coreProblems: [
    "Empty slots despite having capacity",
    "Demand has softened but not disappeared",
    "Enquiries are handled reactively",
    "No system to instantly capture and convert leads",
    "Reception team acting as a bottleneck"
  ],

  closingLine: "The issue is not demand it is how quickly and consistently it is converted",

  imperative: {
    quote: "Organic growth and word-of-mouth are no longer enough. Clinics that win today operate systematic revenue capture engines not reactive front desks.",
    tagline: "If nothing changes outcomes ",
    taglineUnderline: "will not change"
  },

  solution: {
    title: "The ClyniCall Revenue Capture System",
    description: "A front-of-house AI layer that sits on top of your existing system and turns every enquiry into a structured booking opportunity"
  },

  components: [
    {
      title: "AI Voice Receptionist",
      features: [
        "Answers every call instantly",
        "Qualifies patients",
        "Captures booking intent"
      ]
    },
    {
      title: "Instant Lead Capture + Callback",
      features: [
        "Captures website enquiries",
        "Calls back within minutes"
      ]
    },
    {
      title: "AI Chat Assistant",
      features: [
        "Engages website visitors",
        "Answers questions",
        "Drives booking intent"
      ]
    }
  ],

  systemNote: "Designed to work alongside your existing system (EXACT), not replace it",

  howItWorks: [
    {
      step: 1,
      title: "Patient enquires via call or website"
    },
    {
      step: 2,
      title: "AI responds instantly"
    },
    {
      step: 3,
      title: "Booking intent captured"
    },
    {
      step: 4,
      title: "Structured request sent to reception"
    },
    {
      step: 5,
      title: "Reception confirms and books in EXACT"
    }
  ],

  workflowNote: "This increases booking speed without disrupting existing workflow",

  transformation: {
    phases: [
      {
        title: "Week 1-2: Setup",
        items: [
          "System configuration",
          "Workflow mapping",
          "AI training setup",
          "Integration alignment"
        ]
      },
      {
        title: "Week 2-4: Testing",
        items: [
          "Live call handling begins",
          "Lead capture activated",
          "Response optimisation",
          "Conversion tracking"
        ]
      },
      {
        title: "Week 4-6: Deployment",
        items: [
          "Full rollout across channels",
          "Performance stabilisation"
        ]
      },
      {
        title: "Week 6+: Results",
        items: [
          "Increased booking conversion",
          "Reduced missed enquiries",
          "Higher utilisation of chair capacity",
          "Predictable demand flow"
        ]
      }
    ]
  },

  value: {
    scenarios: [
      {
        scenario: "+2 bookings/day",
        monthlyImpact: "+£10,000/month"
      },
      {
        scenario: "50% efficiency",
        monthlyImpact: "+£5,000/month"
      }
    ],
    note: "This system does not create demand it captures the demand you are already missing"
  },

  comparison: [
    {
      competitor: "Boxly",
      theirApproach: [
        "Passive lead capture",
        "No instant response",
        "Widget covers your existing website CTAs"
      ],
      ourApproach: [
        "Instant engagement",
        "Real-time conversion"
      ]
    },
    {
      competitor: "Social Media Ads",
      theirApproach: [
        "Expensive",
        "Unpredictable"
      ],
      ourApproach: [
        "Converts existing demand first",
        "Predictable"
      ]
    },
    {
      competitor: "Reception only model",
      theirApproach: [
        "Slow response",
        "Limited capacity"
      ],
      ourApproach: [
        "Instant + scalable conversion layer"
      ]
    }
  ],

  pricing: {
    title: "Investment in The ClyniCall Revenue Capture System",
    monthly: "£2,000 per month",
    implementation: "£3,500 one-time implementation fee",
    positioning: "This is not software pricing it is a revenue capture system designed to increase booked appointments and improve utilisation of existing capacity",
    roiFraming: "Offset by the system if it simply captures an extra 2 bookings a week"
  },

  finalCTA: {
    title: "Your Path to 15-25% More Booked Appointments in 30 Days",
    timeline: [
      {
        period: "Week 1-2",
        action: "Setup"
      },
      {
        period: "Week 2-4",
        action: "Testing"
      },
      {
        period: "Week 4-6",
        action: "Deployment"
      },
      {
        period: "Week 6+",
        action: "Results"
      }
    ],
    buttonText: "Start Pilot"
  },

  pilotForm: {
    title: "Start Pilot Program",
    fields: [
      {
        name: "clinicName",
        label: "Clinic name",
        type: "text",
        defaultValue: "Platinum Dental Care",
        required: true
      },
      {
        name: "contactName",
        label: "Main point of contact",
        type: "text",
        required: true
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true
      },
      {
        name: "phone",
        label: "Phone number",
        type: "tel",
        required: true
      },
      {
        name: "startDate",
        label: "Preferred start date",
        type: "date",
        required: true
      },
      {
        name: "goal",
        label: "Primary goal",
        type: "textarea",
        required: true
      }
    ],
    confirmation: "Confirm that once this is submitted a contract will be drafted and you will be sent an invoice for the one-time implementation cost",
    submitEmail: "ali@clynicall.co.uk"
  }
};
